import { isTouchEvent } from 'chessboard/model/dom/is-touch-event';

/**
 * Determine whether or not a DOM event is caused by the right button.
 */
export function isRightButton(event: MouseEvent | PointerEvent | TouchEvent): boolean {
  return !isTouchEvent(event) && (<MouseEvent | PointerEvent>event).which === 3;
}
